import { render, staticRenderFns } from "./PDFChatViewer.vue?vue&type=template&id=a9d0be4e&scoped=true&"
import script from "./PDFChatViewer.vue?vue&type=script&lang=js&"
export * from "./PDFChatViewer.vue?vue&type=script&lang=js&"
import style0 from "./PDFChatViewer.vue?vue&type=style&index=0&id=a9d0be4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d0be4e",
  null
  
)

export default component.exports